<template>
	<div
		:class="['helper-button-container', {'bottom-distance' : bottomDistance}, {'bottom-distance-mobile' : bottomDistanceOnMobile}]"
		@mouseleave="hideOptions"
		@click="toggleOptions($event)"
	>
		<div :class="['question-icon', {'close' : showOptions}]">{{!showOptions ? `?` : `&#x2715;`}}</div>
		<div :class="['circle', {'close-circle' : showOptions}]"></div>

		<div :class="['help-tooltip']">
			<div v-if="showOptions" class="assistance">
				<a
					class="assistance-generic contact"
					href="mailto:pavlina.venkova@akkodis.com"
					@click.prevent="emailCmt"
					v-if="hasContactCmt"
				>
					{{$t('common.footer.contactCMT')}}
				</a>

				<span
					class="assistance-generic show-dialog"
					@click.prevent="handleReportDialogShow($event)"
					v-if="hasReportAProblem"
				>
					{{ $t('common.footer.reportProblem')}}
						<ReportAProblem
							v-if="showSendReportDialog"
							@closeDialog="handleReportDialogClose"
							@handleMessage="sendEmailForProblem"
							:title="`${ $t('projectPage.what')}`"
							:sending="sending"
						/>
				</span>

				<span
					class="assistance-generic resources"
					@click.prevent="redirectToResources"
					v-if="hasResources"
				>
					{{$t('common.footer.resources')}}
				</span>

				<div
					class="assistance-generic assistance-container"
					v-if="hasAssistance"
				>
					<span class="assistance-message">Contact this email for assistance</span>
					<span class="assistance-email" @click="(event) => copyEmail(event)">pavlina.venkova@akkodis.com</span>
				</div>

			</div>

			<div v-else class="assistance">
				<span class="assistance-generic normalized">{{$t('common.needHelp')}}</span>
			</div>
		</div>
	</div>
</template>

<script>
import ReportAProblem from "@/drc/components/ReportAProblem";
import reportAProblemMixin from "@/drc/mixins/report-a-problem-mixin";
import {NOTIFICATION_TYPE} from "@/common/utils/constants";
import {EventBackToTopButton} from "@/common/configurations/event-bus";

export default {
	name: "HelperButton",
	mixins: [reportAProblemMixin],
	components: {
		ReportAProblem,
	},
	props: {
		hasReportAProblem: {
			type: Boolean,
			required: false,
			default: true
		},
		hasResources: {
			type: Boolean,
			required: false,
			default: true
		},
		hasContactCmt: {
			type: Boolean,
			required: false,
			default: true
		},
		hasAssistance: {
			type: Boolean,
			required: false,
			default: true
		},
		bottomDistance: {
			type: Boolean,
			required: false,
			default: false
		},
		bottomDistanceOnMobile: {
			type: Boolean,
			required: false,
			default: false
		}
	},
	data() {
		return {
			showOptions: false
		}
	},
	mounted() {
		EventBackToTopButton.$on('closeDialog', this.hideOptions)
	},
	beforeDestroy() {
		EventBackToTopButton.$off('closeDialog')
	},
	methods: {
		copyEmail(event) {
			navigator.clipboard.writeText(event.target.textContent)
				.then(() => this.showNotification(`Email was copied successfully.`, NOTIFICATION_TYPE.SUCCESS))
				.catch((error) => {
					console.error(error);
					this.showNotification(`Failed to copy the email.`, NOTIFICATION_TYPE.ERROR);
				});
		},
		emailCmt() {
			const email = 'pavlina.venkova@akkodis.com';
			window.location.href = `mailto:${email}`;
		},
		redirectToResources() {
			this.$router.push("/resources")
		},
		toggleOptions(event) {
			if (!event.target.classList.contains('assistance-generic') && !event.target.closest('.project-report-email-popup')) {
				this.showOptions = !this.showOptions
			} else {
				event.preventDefault()
			}
		},
		hideOptions() {
			this.showOptions = false
		}
	}
}
</script>

<style lang="scss" scoped>
@import "@/common/assets/css/_variables.scss";

.helper-button-container {
	width: 56px;
	height: 56px;
	position: fixed;
	bottom: 0;
	right: 0;
	cursor: pointer;
	margin: 35px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	z-index: 13;

	@media (max-width: $mobile) {
		right: -24px;
	}

	&.bottom-distance {
		bottom: 65px;
	}

	&.bottom-distance-mobile {
		@media (max-width: $tablet) {
			bottom: 58px;
		}
	}

	.question-icon {
		font-family: Roboto, serif;
		font-size: 20px;
		font-weight: 300;
		width: 26px;
		height: 26px;
		background-color: rgba(0, 0, 0, 0.2);
		color: rgba(255, 255, 255, 0.7);
		text-align: center;
		line-height: 26px;
		border-radius: 50%;
		user-select: none;
		border: 1px solid transparent;

		&.close {
			font-size: 17px;
			line-height: 24px;
		}
	}

	.circle {
		position: absolute;
		z-index: 14;
		width: 56px;
		height: 56px;
		background: rgba(255, 255, 255, 0.5);
		border-radius: 50%;
		--webkit-mask-image: radial-gradient(circle at 30px 30px, transparent 40px, black 60px);
		mask-image: radial-gradient(circle at 28px 28px, transparent 13px, black 13px);
		border: 1px solid #3C3C432E;

		&.close-circle {
			width: 44px;
			height: 44px;
			mask-image: radial-gradient(circle at 22px 22px, transparent 9px, black 13px);
			border: 1px solid #ffb81c;
		}
	}

	.help-tooltip {
		display: none;
		position: absolute;
		bottom: calc(100% + 12px);
		width: fit-content;
		min-width: 164px;
		right: 0;
		background: white;
		color: black;
		font-family: Roboto, serif;
		font-weight: 400;
		font-size: 13px;
		line-height: 13px;
		text-align: center;
		border-radius: 4px;
		z-index: 15;
		border: 1px solid #E5E5EA;
		box-shadow: 0 25px 21px -5px #0000001A;
		box-shadow: 0 2px 25px -5px #00000029;

		.assistance {
			display: flex;
			flex-direction: column;
			justify-content: left;
			gap: 5px;
			text-align: left;
			padding-top: 5px;
			padding-bottom: 5px;

			.assistance-generic {
				display: flex;
				flex-direction: row;
				font-size: 13px;
				font-family: Roboto, serif;
				font-weight: 400;
				width: 100%;
				align-items: flex-start;
				margin: 0;
				text-align: start;
				padding-left: 15px;
				padding-right: 15px;
				padding-top: 10px;
				padding-bottom: 10px;
				color: black;

				&:hover {
					background: #F2F2F7;
				}

				&.normalized {
					&:hover {
						background: transparent;
					}
				}
			}

			.assistance-container {
				display: flex;
				flex-direction: column;
				align-items: flex-start;
				gap: 12px;

				&:hover {
					background: transparent;
				}

				.assistance-message {
					font-size: 13px;
					font-family: Roboto, serif;
					font-weight: 400;
					color: #7A7A7A;
				}

				.assistance-email {
					font-size: 13px;
					font-family: Roboto, serif;
					font-weight: 400;
					color: $drc-dark-blue;
				}
			}
		}

		&:after {
			content: "";
			position: absolute;
			top: 100%;
			right: 20px;
			border-left: 7px solid transparent;
			border-right: 7px solid transparent;
			border-bottom: 11px solid white;
			transform: rotate(180deg);
			z-index: 15;
		}

		&:before {
			width: 100%;
			min-width: 70px;
			height: 50px;
			background: transparent;
			content:'';
			bottom: -50px;
			left: 0;
			z-index: 15;
			position: absolute;
		}
	}

	&:hover {
		.question-icon {
			border: 1px solid #ffb81c;
			color: #ffb81c;
			background: #001f33;
		}

		.circle {
			background: #001f33;
		}

		.help-tooltip {
			display: block;
		}
	}
}
</style>
